var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-btn',{attrs:{"to":{ name: 'Login' },"text":""}},[_c('v-icon',[_vm._v("mdi-logout")]),_vm._v(" Iniciar sesión ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }